import { useRouter } from "next/router";
import React from "react";

const Section_name = ({ name, color, margin }) => {
  const router = useRouter();
  const lang = router.locale;
  return (
    <div key={lang} className={`${margin} `}>
      <h2
        className={`text-[#1D1D1B] lg:text-[40px] text-[32px] font-bold w-[100%] leading-[56px]`}
      >
        {name}
      </h2>
      <hr
        style={{ backgroundColor: color }}
        className={`h-[5px] w-[138px]  mb-[24px] rounded-[22.5px]`}
      ></hr>
    </div>
  );
};

export default Section_name;
